/**
 * a proxy for repeated timeouts
 */
var timers = new Map();

var Timer = {

    /**
     * set a timer for given callback function
     *
     * @param {string} id identifier for the timeout, should be unique so
     *        repeated invocations will not lead to repeated timer additions
     * @param {Function} callback to execute once timeout delay has passed
     * @param {number} delay in milliseconds
     * @return {number} set timeout id
     */
    set: function( id, callback, delay ) {
        if ( typeof id !== "string" ) {
            throw new Error( "cannot set Timer without a valid identifier" );
        }

        // unset existing Timeout
        Timer.clear( id );

        // short delays can be executed on a requestAnimationFrame for
        // better performance (no point in cancelling this one btw)

        if ( delay < 5 ) {
            return window.requestAnimationFrame( callback );
        }
        else {
            var timeout = setTimeout( callback, delay );
            timers.set( id, timeout );
            return timeout;
        }
    },

    /**
     * clears a pending timeout for given id
     *
     * @param {string} id
     */
    clear: function( id ) {
        if ( timers.has( id )) {
            clearTimeout( timers.get( id ));
            timers.delete( id );
        }
    }
};

export default Timer